import gql from 'graphql-tag';

export const GET_SERVICE_RUNS_DAILY_LABELS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				planned
				order
				machineCount
				route {
					id
					name
				}
				driver {
					id
					username
					firstname
					lastname
				}
				vehicle {
					id
					name
				}
				serviceDockets {
					id
					order
					place {
						id
						name
					}
					location {
						id
						name
					}
					machine {
						id
						assetId
						place {
							id
							name
						}
						location {
							id
							name
						}
					}
				}
			}
			count
		}
	}
`;

export default GET_SERVICE_RUNS_DAILY_LABELS;
